export default "__VITE_ASSET__BB9UpXKi__"